import { forwardRef, useState, useEffect } from "react";
import classes from "./faqs.module.css";
import { ReactComponent as Plus } from "../../../assets/svgs/plus.svg";
import { ReactComponent as Minus } from "../../../assets/svgs/minus.svg";

const FAQ_ARRAY = [
  {
    id: "question1",
    question: "How can I get matched as a Talent",
    answer: `You can get matched by ensuring you <a href='${window.location.origin}/register'>signup</a>, fill up all onboarding forms and doing your tests. From there you can search for any job according to your specifications and apply for it. Or you can leave it to us to match you automatically with any client that meets your specifications or that needs you`,
  },
  {
    id: "question2",
    question: "How can I get matched as a Client",
    answer: `As a Client, all you have to do is to <a href='${window.location.origin}/register'>create an account</a> and <a href='${window.location.origin}#premium-access'>subscribe</a> to a plan. Fulfill all onboarding pages and processes, then create a job. We will then match you with a talent only if you are on a current pricing plan. But remember that you get a free trial on first signup 😉`,
  },
  {
    id: "question3",
    question: "What job roles are available on Awasource?",
    answer: `For now just these (we hope to add more going forward): software engineers, developers, designers, product managers, product developers, UX designer, architects, project managers, accountants, data analyst, business analyst, financial analyst, marketing manager, product designer, digital marketers, writers, content creators, tutors, artists, visual creators, IT specialists, information security, networking hardware specialist, intern, student-worker`,
  },
  {
    id: "question4",
    question: "What is a Gig?",
    answer: `A role or need that a client is ready to pay a talent to fulfill for a period of 6 months or less`,
  },
  {
    id: "question5",
    question: "What is a Job?",
    answer: `A role or need that a client is ready to pay a talent to fulfill for a period of more than 6 months`,
  },
  {
    id: "question6",
    question: "How diverse is Awasource?",
    answer: `We provide a wide diverse range of talents for clients. We do not exclude any qualified candidates on the basis of race, ethnicity, or gender. We do not show photos, last names, or contact details to reduce bias, until a client matches with a talent.`,
  },
  {
    id: "question7",
    question: "What is KYC?",
    answer: `Know Your Customer or KYC check is the mandatory process of identifying and verifying your identity when opening an account with us. In other words, we must make sure that you are genuinely who you claim to be. We would use the records our Talents and Clients give us to make sure they are legit. `,
  },
];

const FAQS = forwardRef((prop, ref) => {
  const [number, setNumber] = useState(undefined);

  useEffect(() => {
    try {
      const faqData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_ARRAY.map((q) => ({
          "@type": "Question",
          name: q.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: q.answer.replace(/<[^>]*>/g, " ").trim(),
          },
        })),
      };

      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "faq-schema";
      script.text = JSON.stringify(faqData);
      document.body.appendChild(script);

      return () => {
        const el = document.getElementById("faq-schema");
        if (el && el.parentNode) el.parentNode.removeChild(el);
      };
    } catch (e) {
      // fail silently... schema injection is non-critical.
    }
  }, []);

  return (
    <section className={classes.section} id="faqs" ref={ref}>
      <h2 className="subtitle center mt-bg mb-bg">
        Frequently asked questions
      </h2>
      <div className={classes.faqs}>
        {FAQ_ARRAY.map((item) => (
          <Question
            key={item.id}
            number={number}
            setNumber={setNumber}
            {...item}
          />
        ))}
      </div>
    </section>
  );
});

const Question = ({ question, answer, id, number, setNumber }) => {
  const handleSelect = () => setNumber(id);

  return (
    <div className={classes.questions}>
      <div
        className={`flex ${classes.container} ${number === id ? classes.blue : classes.grey
          }`}
        onClick={handleSelect}
      >
        <p>{question}</p>
        {number !== id ? <Plus /> : <Minus />}
      </div>
      {number === id && (
        <p
          className={classes.answer}
          dangerouslySetInnerHTML={{
            __html: answer,
          }}
        />
      )}
    </div>
  );
};
export default FAQS;
